interface SvgBoxProps {
  children: React.ReactNode
  width?: number
  offset?: number
}

const SvgBox = ({ children, width, offset }: SvgBoxProps) => {
  return (
    <div
      style={{
        display: 'flex',
        minWidth: `${width}px`,
        transform: `translateY(${offset}px)`
      }}
    >
      {children}
    </div>
  )
}

export default SvgBox
